export interface NavRoute {
  name: string;
  url: string;
  urlActivationParams?: string[] | undefined;
  isSideMenu: boolean;
  isVisible: boolean;
  parameters?: string[];
  icon?: string;
  requireParameters?: string[];
  urlTree?: string[];
  subRoutes?: NavRoute[];
  svgIcon?: string;
  flag?: string;
  activeIn?: string;
  isSubRoute?: boolean;
}

export const NavRoutes: NavRoute[] = [
  {
    name: 'Scootaverses',
    url: '/home/scootaverses',
    isSideMenu: false,
    isVisible: false,
    activeIn: '',
  },
  {
    name: 'Rooms',
    url: '/home/scootaverses/:id/rooms',
    urlActivationParams: ['home', 'scootaverses', 'rooms'],
    isSideMenu: true,
    isVisible: true,
    parameters: ['id'],
    icon: 'home',
    requireParameters: ['id'],
    urlTree: ['Rooms'],
    subRoutes: [
      {
        name: 'Settings',
        url: '/home/scootaverses/:id/room/:room-id/settings',
        urlActivationParams: ['home', 'scootaverses', 'room', 'settings'],
        isSideMenu: true,
        isSubRoute: true,
        isVisible: true,
        icon: 'settings',
        parameters: ['id', 'room-id'],
        requireParameters: ['room-id'],
        urlTree: ['room_name', 'Settings'],
      },
      {
        name: 'Advanced Settings',
        url: '/home/scootaverses/:id/room/:room-id/advanced-settings',
        urlActivationParams: ['home', 'scootaverses', 'room', 'advanced-settings'],
        isSideMenu: true,
        isSubRoute: true,
        isVisible: true,
        parameters: ['id', 'room-id'],
        requireParameters: ['room-id'],
        urlTree: ['room_name', 'Advanced Settings'],
      },
    ],
  },
  {
    name: 'Smart Badging',
    url: '/home/scootaverses/:id/smart-badging',
    urlActivationParams: ['home', 'scootaverses', 'smart-badging'],
    isSideMenu: true,
    isVisible: true,
    parameters: ['id'],
    icon: 'pages',
    urlTree: ['Smart Badging'],
  },
  {
    name: 'Entry Flows',
    url: '/home/scootaverses/:id/entry-flows',
    urlActivationParams: ['home', 'scootaverses', 'entry-flows'],
    isSideMenu: true,
    isVisible: true,
    parameters: ['id'],
    svgIcon: 'FRAME_CONFIG',
    flag: 'entry_flows_v1',
    urlTree: ['Entry Flows'],
  },
  {
    name: 'New Entry Flow',
    url: '/home/scootaverses/:id/entry-flows/create-flow',
    urlActivationParams: ['home', 'scootaverses', 'entry-flows', 'create-flow'],
    isSideMenu: true,
    isVisible: false,
    parameters: ['id'],
    icon: 'pages',
    flag: 'entry_flows_v1',
    urlTree: ['Create New Flow'],
  },
  {
    name: 'Edit Entry Flow',
    url: '/home/scootaverses/:id/entry-flows/edit-flow/:flow-id',
    urlActivationParams: ['home', 'scootaverses', 'entry-flows', 'edit-flow'],
    isSideMenu: true,
    isVisible: false,
    parameters: ['id', 'flow-id'],
    urlTree: ['Edit Flow'],
  },
  {
    name: 'Settings',
    url: '/home/scootaverses/:id/settings',
    urlActivationParams: ['home', 'scootaverses', 'settings'],
    isSideMenu: true,
    isVisible: true,
    parameters: ['id'],
    icon: 'settings',
    urlTree: ['Settings'],
  },
  {
    name: 'Create Room',
    url: '/home/scootaverses/:id/create-room',
    isSideMenu: false,
    isVisible: false,
    urlActivationParams: ['home', 'scootaverses', 'create-room'],
    parameters: ['id'],
    urlTree: ['Create Room'],
  },
  {
    name: 'Edit Room',
    url: '/home/scootaverses/:id/edit-room/:room-id',
    isSideMenu: false,
    isVisible: false,
    urlActivationParams: ['home', 'scootaverses', 'edit-room'],
    parameters: ['id', 'room-id'],
    urlTree: ['Room Creator'],
  },
  {
    name: 'Editor Item Room',
    url: '/home/scootaverses/:id/room-editor/:room-id',
    isSideMenu: false,
    isVisible: false,
    urlActivationParams: ['home', 'scootaverses', 'room-editor'],
    parameters: ['id', 'room-id'],
    urlTree: ['Room Creator'],
  },
  {
    name: 'Edit Room',
    url: '/home/scootaverses/:id/room-editor/:room-id/step/:step-id',
    isSideMenu: false,
    isVisible: false,
    urlActivationParams: ['home', 'scootaverses', 'room-editor', 'step'],
    parameters: ['id', 'room-id', 'step-id'],
    urlTree: ['Room Creator'],
  },
];

export const ParamsRelations = [{ id: 'scootaverseId' }, { 'room-id': 'socialId' }];
